import styled from "styled-components";

export const Container123 = styled.header`
  width: 100%;
  height: 90px;
  background: white;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  div {
    img {
      width: 150px;
      height: auto;
      cursor: pointer;
    }

    span {
      color: #e71037;
      font-weight: 800;
      font-size: 0.7rem;
    }
  }
`;
